// extracted by mini-css-extract-plugin
export default {"container":"EmailPeriod_container__2quEl","icon":"EmailPeriod_icon__-ivr5"};